<fui-checkbox-control [label]="label" [attr.id]="elementId" [readOnly]="isReadonly" [(ngModel)]="value">
</fui-checkbox-control>
